export default {
  API_ENDPOINT: 'https://mysterious-cliffs-03197.herokuapp.com/api',
  TOKEN_KEY: process.env.TOKEN_KEY,
}